var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg",class:{ msgShow: _vm.show }},[_vm._v(" "+_vm._s(_vm.txt)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }